module.exports = __webpack_public_path__ + "static/img/logo-nuevo.923438a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-nuevo.png
// module id = 49
// module chunks = 1